// brooch.js: v7 HAUTE COSMOS world. SCALE: the Milky Way as a pave brooch on a black velvet board, one stone marked You are here.
// STUB: re-exports the v5 galaxy world so the site keeps working until the brooch agent swaps in './brooch/world.js'.
// Owner: the brooch agent (see web/src/worlds/V7.md).
export { create } from './galaxy.js';
